import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-8 3.5v2h-2v-2h2zM10.5 10c0-.844.59-1.5 1.5-1.5.523 0 .88.17 1.105.395.225.224.395.582.395 1.105 0 .32-.081.462-.168.57-.113.14-.251.244-.507.437l-.183.14c-.335.256-.774.615-1.11 1.178-.343.574-.532 1.279-.532 2.175h2c0-.604.123-.94.25-1.15.133-.223.318-.394.608-.615.035-.028.076-.058.12-.09.255-.191.626-.468.909-.817.382-.472.613-1.06.613-1.828 0-.977-.33-1.87-.98-2.52-.65-.65-1.543-.98-2.52-.98-2.09 0-3.5 1.627-3.5 3.5h2z",
      "clip-rule": "evenodd"
    })
  ]))
}